import { HskEntry } from "./types";

/** Strip tone marks and normalize ü/v so plain ASCII pinyin matches toned forms. */
export const stripPinyinTones = (text: string): string =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ü/g, "u")
    .replace(/v/g, "u");

export const filterCardsByQuery = (cards: HskEntry[], query: string): HskEntry[] => {
  const trimmed = query.trim();
  if (!trimmed) {
    return cards;
  }

  const queryLower = trimmed.toLowerCase();
  const queryPinyin = stripPinyinTones(trimmed);

  return cards.filter(
    (card) =>
      card.charSimp.includes(trimmed) ||
      card.charTrad.includes(trimmed) ||
      stripPinyinTones(card.pinyin).includes(queryPinyin) ||
      card.meaning.toLowerCase().includes(queryLower)
  );
};
